import React, { Component } from "react";
import { txtBox } from "../utils/Forms";
import { Link } from "react-router-dom";
import _ from "lodash";

export default class AdminUpdateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      errors: {},
      loading: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setFormData(admin = {}) {
    const formData = {
      id: admin.id || null,
      last_name: admin.last_name || "",
      first_name: admin.first_name || "",
      email: admin.email || "",
      super_admin: admin.super_admin || false
    };

    this.setState({ formData, loading: false });
  }

  componentWillReceiveProps(nextProps) {
    this.setFormData(nextProps.admin);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;

    const updatedFormData = { ...this.state.formData, [name]: value };
    this.setState({ ...this.state, formData: updatedFormData });
  }

  isFormValid(formData) {
    let errors = {};
    const { first_name, last_name, email } = formData;

    if (_.isEmpty(first_name)) {
      errors["first_name"] = "First name is required";
    }

    if (_.isEmpty(last_name)) {
      errors["last_name"] = "Last name is required";
    }

    if (_.isEmpty(email)) {
      errors["email"] = "Email is required";
    }

    this.setState({ errors });
    return _.isEmpty(errors);
  }

  handleSubmit(event) {
    if (this.isFormValid(this.state.formData)) {
      this.props.saveAdmin(this.state.formData);
    }
    event.preventDefault();
  }

  render() {
    const { first_name, last_name, email, super_admin } = this.state.formData;
    const { errors, loading } = this.state;
    const loadingView = (
      <div style={{ textAlign: "center" }}> Loading... please wait </div>
    );
    const form = (
      <div className="row">
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix col-md-offset-3">
            <div className="row">
              {txtBox("First Name", "first_name", first_name, this, { errors })}
              {txtBox("Last Name", "last_name", last_name, this, { errors })}
            </div>
            <div className="row">
              {txtBox("Email", "email", email, this, { errors })}
            </div>
            <div className="row">
              <div className="form-group col-md-12">
                <label>
                  <input
                    type="checkbox"
                    name="super_admin"
                    checked={super_admin}
                    onChange={this.handleChange}
                  />
                  {" "}
                  Is Super Admin?
                </label>
              </div>
            </div>

          </div>
          <div className="row">
            <div
              style={{ textAlign: "center" }}
              className="col-md-12 edit-buttons-pane"
            >
              <Link
                to="/admins"
                className="btn btn-default"
                style={{ marginRight: 10 }}
              >
                {" "}Cancel{" "}
              </Link>
              <input
                className="btn btn-success "
                type="submit"
                value="Update Administrator"
              />
            </div>
          </div>

        </form>
      </div>
    );

    const view = loading ? loadingView : form;
    return (
      <div>
        {view}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminUpdateForm.js